import React from 'react';
import { Line } from 'react-chartjs-2';

const chartHeight = 380;

class LineChart extends React.Component {

  /**
   *
   * @function render
   * @memberof LineChart
   *
   * Renders the component.
   *
   * @return {string} - HTML markup for the component
   */
  render() {
    const {heading, axisLabels, labels, disclaimer} = this.props.data;
    const {chartOptions, chartData} = this.props;

    return (
      <div className="nppe2-fc-feeding-guidelines-line-chart" id="fc-screenshot-feeding-guidelines-line-chart">
        <div className="row">

          <div className="col-xs-12 nppe2-fc-sub-title-output">
            {heading}
          </div>

          <div className="col-xs-12">

            <div className="nppe2-fc-feeding-guidelines-line-chart__axis-label--x">
              {axisLabels.x}
            </div>
            <div className="nppe2-fc-feeding-guidelines-line-chart__content">
              <Line
                data={chartData}
                options={chartOptions}
                height={chartHeight}
              />
            </div>

            <div className="row nppe2-fc-feeding-guidelines-line-chart__margin-left">
              <div className="col-xs-5 text-center nppe2-fc-feeding-guidelines-line-chart__axis-label--y">
                {axisLabels.y}
              </div>
              <div className="col-xs-7 text-right nppe2-fc-feeding-guidelines-line-chart__label">
                <div className="nppe2-fc-feeding-guidelines-line-chart__label--orange">
                  {labels.minPerWeek}
                </div>
                <div className="nppe2-fc-feeding-guidelines-line-chart__label--purple">
                  {labels.maxPerWeek}
                </div>
              </div>
              <div className="col-xs-5"></div>
              <div className="col-xs-7 nppe2-fc-feeding-guidelines-line-chart__bottom--copy">
                <p>{disclaimer}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
};

export default LineChart;
